export const endereco = {
    PESQUISA_ESTADOS: 'PESQUISA_ESTADOS',
    PESQUISA_PAIS: 'PESQUISA_PAIS',
    PESQUISA_TIPOLOGRAOURO: 'PESQUISA_TIPOLOGRAOURO',    
    PESQUISA_CEP: 'PESQUISA_CEP',
    PESQUISA_CIDADES: 'PESQUISA_CIDADES'
}